import {Injectable} from '@angular/core';
import {HeaderService} from './header.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class DeviceService extends HeaderService {
    getDevicesByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getDevicesByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createDevice(Device: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'device/',
            JSON.stringify(Device),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateDevice(Device: any, id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'device/' + id,
            JSON.stringify(Device),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getDeviceById(id: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'device/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteDevice(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'device/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAllDevicesForSuperAdmin(page: number, name: string, deviceType?: number): Observable<any> {
        let query = {
            page: page,
            name: name
        };

        if (deviceType) {
            query['deviceType'] = parseInt(deviceType.toString());
        }
        return this.http.post(environment.apiBaseUrl + 'get-all-devices-for-super-admin/', query,
        this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    createDeviceWithUser(Device: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'upt/create-device-with-user',
            JSON.stringify(Device),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    triggerLogSocket(deviceId: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'upt/device-file-log/' + deviceId,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }


    getAllDeviceLog(data: any, filter): Observable<any> {
        const query = {
            page: data.page,
            limit: data.limit,
            filter: filter,
            sort: {}
        };
        return this.http.post(environment.apiBaseUrl + 'upt/getErrorLogFileList', query,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    downloadErrorFile(filename): Observable<any> {

        const header = {
            headers: new HttpHeaders({
                'Content-Type': 'application/zip',
                'Authorization': 'Bearer ' + this.token,
                'Accept': '*/*'
            })
        };
        return this.http.get(environment.apiBaseUrl + 'upt/downloadErrorLog/' + filename,{responseType: 'blob'});
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/device.service.ts